import request from '../utils/request'
import { clearLfAdminSession, getLfAdminToken } from '@/utils/lfAdminSession'

function withAdminToken(params = {}) {
  const token = getLfAdminToken()
  return token ? { ...params, lf_admin_token: token } : params
}

function redirectToAdminLogin() {
  if (typeof window === 'undefined') return
  const currentPath = window.location.hash && window.location.hash.startsWith('#/')
    ? window.location.hash.slice(1)
    : window.location.pathname
  if (currentPath.startsWith('/admin-login')) return
  const redirect = encodeURIComponent(currentPath || '/lf-admin/dashboard')
  window.location.hash = `#/admin-login?redirect=${redirect}`
}

function handleAdminResponse(promise) {
  return promise.then((res) => {
    if (res && res.data && Number(res.data.code) === -401) {
      clearLfAdminSession()
      redirectToAdminLogin()
    }
    return res
  })
}

function postRequest(functionName, params = {}) {
  return handleAdminResponse(request.post('./index.php', {
    function: functionName,
    ...withAdminToken(params)
  }))
}

export { postRequest }

export function learningFirstAdminSendLoginCode() {
  return request.post('./index.php', {
    function: 'learningFirstAdminSendLoginCode'
  })
}

export function learningFirstAdminLogin(adminCode) {
  return request.post('./index.php', {
    function: 'learningFirstAdminLogin',
    admin_code: adminCode
  })
}

export function verifyLearningFirstAdminSession() {
  return postRequest('verifyLearningFirstAdminSession')
}

export function learningFirstAdminLogout() {
  return postRequest('learningFirstAdminLogout')
}

export function getModels() {
  return request.post('./AIChat/index.php', {
    function: 'getModels'
  })
}

export function updateAIModelConfig(params) {
  return postRequest('updateAIModelConfig', params)
}

export function removeAIModelConfig(id) {
  return postRequest('removeAIModelConfig', { id })
}

export function listEditorBundles(params = {}) {
  return postRequest('listEditorBundles', params)
}

export function getEditorBundle(params) {
  return postRequest('getEditorBundle', params)
}

export function createEditorBundle(params) {
  return postRequest('createEditorBundle', params)
}

export function updateEditorBundle(params) {
  return postRequest('updateEditorBundle', params)
}

export function deleteEditorBundle(params) {
  return postRequest('deleteEditorBundle', params)
}

export function searchCollectionsForAdmin(params) {
  return postRequest('searchCollectionsForAdmin', params)
}

export function listCertTracks(params = {}) {
  return postRequest('listCertTracks', params)
}

export function createCertTrack(params) {
  return postRequest('createCertTrack', params)
}

export function updateCertTrack(params) {
  return postRequest('updateCertTrack', params)
}

export function deleteCertTrack(params) {
  return postRequest('deleteCertTrack', params)
}

export function listAiSearchTurns(params = {}) {
  return postRequest('adminListAiSearchTurns', params)
}

export function getAiSearchConversation(params) {
  return postRequest('adminGetAiSearchConversation', params)
}

export function updateAiSearchTurnReview(params) {
  return postRequest('adminUpdateAiSearchTurnReview', params)
}

export function getAiSearchInsights(params = {}) {
  return postRequest('adminGetAiSearchInsights', params)
}

export function generateAiSearchContentIdeas(params = {}) {
  return postRequest('adminGenerateAiSearchContentIdeas', params)
}

export function listAiSearchContentIdeaReports(params = {}) {
  return postRequest('adminListAiSearchContentIdeaReports', params)
}

export function listContactFormSubmissions(params = {}) {
  return postRequest('adminListContactFormSubmissions', params)
}

export function getContactFormSubmission(params) {
  return postRequest('adminGetContactFormSubmission', params)
}

export function approveContactContributionAward(params) {
  return postRequest('adminApproveContactContributionAward', params)
}

export function rejectContactContributionAward(params) {
  return postRequest('adminRejectContactContributionAward', params)
}

export function listPlatformSubscriptions(params = {}) {
  return postRequest('adminListPlatformSubscriptions', params)
}

export function getLearningFirstDashboardStats(params = {}) {
  return postRequest('adminGetLearningFirstDashboardStats', params)
}

export function getUserBehaviorStudy(params = {}) {
  return postRequest('adminGetUserBehaviorStudy', params)
}

export function listUserReadingActivity(params = {}) {
  return postRequest('adminListUserReadingActivity', params)
}

export function getAccountStatusForAdmin(params = {}) {
  return postRequest('adminGetAccountStatus', params)
}

export function updateAccountEmailForAdmin(params = {}) {
  return postRequest('adminUpdateAccountEmail', params)
}

export function updateAccountStatusForAdmin(params = {}) {
  return postRequest('adminUpdateAccountStatus', params)
}

export function getPlatformSubscriptionHistoryForAdmin(params = {}) {
  return postRequest('adminGetPlatformSubscriptionHistory', params)
}

export function voidPlatformSubscriptionInvoice(params = {}) {
  return postRequest('adminVoidPlatformSubscriptionInvoice', params)
}

export function previewPlatformSubscriptionRefund(params = {}) {
  return postRequest('adminPreviewPlatformSubscriptionRefund', params)
}

export function refundPlatformSubscriptionInvoice(params = {}) {
  return postRequest('adminRefundPlatformSubscriptionInvoice', params)
}

export function rollbackPlatformSubscriptionInvoice(params = {}) {
  return postRequest('adminRollbackPlatformSubscriptionInvoice', params)
}

export function cancelPlatformSubscriptionRenewal(params = {}) {
  return postRequest('adminCancelPlatformSubscriptionRenewal', params)
}

export function cancelRefundAndRollbackPlatformSubscription(params = {}) {
  return postRequest('adminCancelRefundAndRollbackPlatformSubscription', params)
}

export function listVouchersForAdmin(params = {}) {
  return postRequest('adminListVouchers', params)
}

export function createVoucherForAdmin(params = {}) {
  return postRequest('adminCreateVoucher', params)
}

export function sendVoucherForAdmin(params = {}) {
  return postRequest('adminSendVoucherNotification', params)
}

export function getAdminOperationsConfig(params = {}) {
  return postRequest('adminGetOperationsConfig', params)
}

export function listAdminCurators(params = {}) {
  return postRequest('adminListCurators', params)
}

export function listAdminCollections(params = {}) {
  return postRequest('adminListCollections', params)
}

export function previewAdminCollectionTransfer(params = {}) {
  return postRequest('adminPreviewCollectionTransfer', params)
}

export function transferAdminCollection(params = {}) {
  return postRequest('adminTransferCollection', params)
}

export function getAdminCollectionFields(id) {
  return postRequest('adminGetCollectionFields', { id })
}

export function updateAdminCollectionFields(params) {
  return postRequest('adminUpdateCollectionFields', params)
}

export function updateAdminOperations(params = {}) {
  return postRequest('adminUpdateOperations', params)
}

export function saveAdminOperationsPlan(params = {}) {
  return postRequest('adminSaveOperationsPlan', params)
}

export function linkAdminOperationsPlan(params = {}) {
  return postRequest('adminLinkOperationsPlan', params)
}

export function deleteAdminCollection(params = {}) {
  return postRequest('adminDeleteCollection', params)
}

export function findAdminCuratorByEmail(params = {}) {
  return postRequest('adminFindCuratorByEmail', params)
}

export function createCreatorEntryTicket(params = {}) {
  return postRequest('adminCreateCreatorEntryTicket', params)
}

export function listCertTrackCollections(params = {}) {
  return postRequest('adminCertTrackCollections', params)
}

// Affiliate program (LearningFirst partners). Mutations are POST-only on the backend.
export function getAffiliateProgramStatus(params = {}) {
  return postRequest('adminGetAffiliateProgramStatus', params)
}

export function setAffiliateIntakeMode(params = {}) {
  return postRequest('adminSetAffiliateIntakeMode', params)
}

export function ensureAffiliateIndexes(params = {}) {
  return postRequest('adminEnsureAffiliateIndexes', params)
}

export function seedAffiliateDefaults(params = {}) {
  return postRequest('adminSeedAffiliateDefaults', params)
}

export function listAffiliateTermsDocuments(params = {}) {
  return postRequest('adminListAffiliateTermsDocuments', params)
}

export function publishAffiliateTermsDocument(params = {}) {
  return postRequest('adminPublishAffiliateTermsDocument', params)
}

export function retireAffiliateTermsDocument(params = {}) {
  return postRequest('adminRetireAffiliateTermsDocument', params)
}

export function createAffiliateInvitation(params = {}) {
  return postRequest('adminCreateAffiliateInvitation', params)
}

export function listAffiliateInvitations(params = {}) {
  return postRequest('adminListAffiliateInvitations', params)
}

export function revokeAffiliateInvitation(params = {}) {
  return postRequest('adminRevokeAffiliateInvitation', params)
}

export function listAffiliates(params = {}) {
  return postRequest('adminListAffiliates', params)
}

export function reviewAffiliate(params = {}) {
  return postRequest('adminReviewAffiliate', params)
}

export function setAffiliateStatus(params = {}) {
  return postRequest('adminSetAffiliateStatus', params)
}

export function setAffiliateManualPayout(params = {}) {
  return postRequest('adminSetAffiliateManualPayout', params)
}

export function listAffiliatePolicies(params = {}) {
  return postRequest('adminListAffiliatePolicies', params)
}

export function saveAffiliatePolicy(params = {}) {
  return postRequest('adminSaveAffiliatePolicy', params)
}

export function publishAffiliatePolicy(params = {}) {
  return postRequest('adminPublishAffiliatePolicy', params)
}

export function retireAffiliatePolicy(params = {}) {
  return postRequest('adminRetireAffiliatePolicy', params)
}

export function previewAffiliatePolicy(params = {}) {
  return postRequest('adminPreviewAffiliatePolicy', params)
}

export function listAffiliateLedger(params = {}) {
  return postRequest('adminListAffiliateLedger', params)
}

export function listAffiliateExceptions(params = {}) {
  return postRequest('adminListAffiliateExceptions', params)
}

export function recoverExpiredWelcomeCheckout(params = {}) {
  return postRequest('adminRecoverExpiredWelcomeCheckout', params)
}

export function prepareAffiliatePayoutBatch(params = {}) {
  return postRequest('adminPrepareAffiliatePayoutBatch', params)
}

export function listAffiliatePayoutBatches(params = {}) {
  return postRequest('adminListAffiliatePayoutBatches', params)
}

export function approveAffiliatePayoutBatch(params = {}) {
  return postRequest('adminApproveAffiliatePayoutBatch', params)
}

export function cancelAffiliatePayoutBatch(params = {}) {
  return postRequest('adminCancelAffiliatePayoutBatch', params)
}

export function dispatchAffiliatePayoutBatch(params = {}) {
  return postRequest('adminDispatchAffiliatePayoutBatch', params)
}

export function reconcileAffiliatePayoutItem(params = {}) {
  return postRequest('adminReconcileAffiliatePayoutItem', params)
}

export function recordManualAffiliatePayout(params = {}) {
  return postRequest('adminRecordManualAffiliatePayout', params)
}

export function listCollectionIdeaProposals(params = {}) {
  return postRequest('adminListCollectionIdeaProposals', params)
}

export function getCollectionIdeaProposal(id) {
  return postRequest('adminGetCollectionIdeaProposal', { id })
}

export function saveCollectionIdeaProposal(params = {}) {
  return postRequest('adminSaveCollectionIdeaProposal', params)
}

export function updateCollectionIdeaProposalStatus(params = {}) {
  return postRequest('adminUpdateCollectionIdeaProposalStatus', params)
}

export function deleteCollectionIdeaProposal(id) {
  return postRequest('adminDeleteCollectionIdeaProposal', { id })
}

export function refreshPlatformSubscriptionPaymentIdentity(params = {}) {
  return postRequest('adminRefreshPlatformSubscriptionPaymentIdentity', params)
}
